import TwitterLogo from "./images/twitter-logo.svg";
import LinkedInLogo from "./images/linkedin-logo.svg";

export default {
  columns: [
    {
      type: "footerColumn",
      groups: [
        {
          type: "linkGroup",
          heading: "Core Capabilities",
          links: [
            {
              type: "internalLink",
              label: "Ad Hoc Analysis",
              url: "https://mode.com/ad-hoc-analysis/"
            },
            {
              type: "internalLink",
              label: "Self-Serve Reporting",
              url: "https://mode.com/self-serve-reporting/"
            },
            {
              type: "internalLink",
              label: "Interactive Dashboards",
              url: "https://mode.com/interactive-dashboards/"
            },
            {
              type: "internalLink",
              label: "Advanced Analytics",
              url: "https://mode.com/advanced-analytics/"
            },
            {
              type: "internalLink",
              label: "Custom Data Apps",
              url: "https://mode.com/custom-data-apps/"
            }
          ]
        },
        {
          type: "linkGroup",
          heading: "Features",
          links: [
            {
              type: "internalLink",
              label: "SQL Editor",
              url: "https://mode.com/online-sql-editor/"
            },
            {
              type: "internalLink",
              label: "Visual Explorer",
              url: "https://mode.com/visual-explorer/"
            },
            {
              type: "internalLink",
              label: "Integrated Notebooks",
              url: "https://mode.com/notebooks/"
            },
            {
              type: "internalLink",
              label: "Reports \u0026 Dashboards",
              url: "https://mode.com/reports-and-dashboards/"
            },
            {
              type: "internalLink",
              label: "Datasets",
              url: "https://mode.com/datasets/"
            },
            {
              type: "internalLink",
              label: "Embedded Analytics",
              url: "https://mode.com/embedded-analytics/"
            },
            {
              type: "internalLink",
              label: "Security",
              url: "https://mode.com/security/"
            },
            {
              type: "externalLink",
              label: "Integrations",
              url: "https://mode.com/data-sources/"
            }
          ]
        }
      ],
      title: "Modern BI"
    },
    {
      type: "footerColumn",
      groups: [
        {
          type: "linkGroup",
          links: [
            {
              type: "externalLink",
              label: "Resource Center",
              url: "https://mode.com/resources/"
            },
            {
              type: "externalLink",
              label: "How Mode compares",
              url: "https://mode.com/comparisons/"
            },
            {
              type: "externalLink",
              label: "Modern BI Tool Kit",
              url: "https://mode.com/toolkits/modern-business-intelligence"
            },
            {
              type: "externalLink",
              label: "Visual Explorer Field Guides",
              url: "https://mode.com/visual-explorer-guides/"
            },
            {
              type: "externalLink",
              label: "Blog",
              url: "https://mode.com/blog/"
            },
            {
              type: "externalLink",
              label: "Example Gallery",
              url: "https://mode.com/example-gallery/"
            },
            {
              type: "externalLink",
              label: "Learn SQL",
              url: "https://mode.com/sql-tutorial/"
            },
            {
              type: "externalLink",
              label: "Learn Python",
              url: "https://mode.com/python-tutorial/"
            },
            {
              type: "externalLink",
              label: "Help \u0026 Support",
              url: "https://mode.com/help/"
            },
            {
              type: "externalLink",
              label: "Mode University",
              url: "https://university.mode.com/"
            },
            {
              type: "externalLink",
              label: "Developer",
              url: "https://mode.com/developer/api-reference/introduction/"
            },

            {
              type: "externalLink",
              label: "Glossary",
              url: "https://mode.com/glossary/"
            },
            {
              type: "externalLink",
              label: "Release Notes",
              url: "https://updates.mode.com/"
            },
            {
              type: "externalLink",
              label: "Partnerships",
              url: "https://mode.com/partnerships/"
            }
          ]
        }
      ],
      title: "Resources"
    },
    {
      type: "footerColumn",
      groups: [
        {
          type: "linkGroup",
          links: [
            {
              type: "internalLink",
              label: "About",
              url: "https://mode.com/about-us/"
            },
            {
              type: "internalLink",
              label: "Careers",
              url: "https://mode.com/careers/"
            },
            {
              type: "externalLink",
              label: "Press",
              url: "https://mode.com/press/"
            },
            {
              type: "externalLink",
              label: "Contact Us",
              url: "https://mode.com/contact-us/"
            },
            {
              type: "externalLink",
              label: "System Status",
              url: "https://status.modeanalytics.com/"
            }
          ]
        }
      ],
      title: "Company"
    }
  ],
  legalLinks: [
    {
      type: "externalLink",
      label: "Terms of Service",
      url: "https://mode.com/legal/tos/"
    },
    {
      type: "externalLink",
      label: "Website Privacy Statement",
      url: "https://mode.com/legal/privacy/"
    }
  ],
  primaryLinks: [
    {
      type: "internalLink",
      label: "Explore Platform",
      url: "https://mode.com/platform/"
    },
    {
      type: "internalLink",
      label: "Customer Stories",
      url: "https://mode.com/customers/"
    },
    {
      type: "externalLink",
      label: "Compare Plans",
      url: "https://mode.com/compare-plans/"
    }
  ],
  socialLinks: [
    {
      type: "socialLink",
      icon: TwitterLogo,
      title: "Twitter",
      url: "https://twitter.com/ModeAnalytics"
    },
    {
      type: "socialLink",
      icon: LinkedInLogo,
      title: "LinkedIn",
      url: "https://www.linkedin.com/company/mode-analytics"
    }
  ]
};
